/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

export const FlagsPermissionCnManifest = {
  permission_cn_manifest_enable: new FcsFlag.Flag(false)
};

export function initFlagsPermissionCnManifest() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureCnManifest", FlagsPermissionCnManifest);
}
